import { render, staticRenderFns } from "./Application.vue?vue&type=template&id=3d975bfe&scoped=true&"
import script from "./Application.vue?vue&type=script&lang=js&"
export * from "./Application.vue?vue&type=script&lang=js&"
import style0 from "./Application.vue?vue&type=style&index=0&id=3d975bfe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d975bfe",
  null
  
)

export default component.exports